<template>
  <div v-if="visible" class="oa-modal-overlay" @click.self="hide">
    <div class="oa-modal oa-modal-sm">
      <div class="oa-modal-header">
        <h3>
          <i class="fa fa-copy oa-modal-icon"></i>
          <span>Copy Settings</span>
        </h3>
        <button class="oa-modal-close" @click="hide">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="oa-modal-body">
        <div class="oa-form-group">
          <label class="oa-form-label">Copy From:</label>
          <select class="oa-form-input" v-model="fromSiteId">
            <option :value="null" disabled>Select source location...</option>
            <option v-for="loc in locations" :key="loc.siteId" :value="loc.siteId">
              {{ loc.name }}
            </option>
          </select>
        </div>

        <div class="oa-form-group">
          <label class="oa-form-label">Copy To:</label>
          <select class="oa-form-input" v-model="toSiteId">
            <option :value="null" disabled>Select destination location...</option>
            <option
              v-for="loc in locations"
              :key="loc.siteId"
              :value="loc.siteId"
              :disabled="loc.siteId === fromSiteId"
            >
              {{ loc.name }}
            </option>
          </select>
        </div>

        <div class="oa-divider-section" style="margin-top: 16px; padding-top: 16px;">
          <label class="oa-form-label">What to copy:</label>
          <div class="oa-checkbox-item">
            <input type="checkbox" id="copy-general" v-model="copyOptions.generalSettings" />
            <label for="copy-general">
              <span>General Settings</span>
              <p class="oa-checkbox-help">Notification email, insurances, display options</p>
            </label>
          </div>
          <div class="oa-checkbox-item">
            <input type="checkbox" id="copy-types" v-model="copyOptions.appointmentTypes" />
            <label for="copy-types">
              <span>Appointment Types</span>
              <p class="oa-checkbox-help">Names, durations, procedure codes (operatory mappings excluded)</p>
            </label>
          </div>
          <div class="oa-checkbox-item">
            <input type="checkbox" id="copy-blocks" v-model="copyOptions.blockoutRules" />
            <label for="copy-blocks">
              <span>Blockout Rules</span>
              <p class="oa-checkbox-help">Don't schedule in these blocks settings</p>
            </label>
          </div>
        </div>

        <div class="oa-warning-box" style="margin-top: 16px;">
          <p>
            <i class="fa fa-exclamation-triangle"></i>
            <strong>Note:</strong> Operatory-Provider mappings will NOT be copied since each location has different providers and operatories. You'll need to configure these manually.
          </p>
        </div>
      </div>

      <div class="oa-modal-footer">
        <button class="oa-btn oa-btn-secondary" @click="hide">Cancel</button>
        <button
          class="oa-btn oa-btn-primary"
          @click="doCopy"
          :disabled="!canCopy || copying"
        >
          <i v-if="copying" class="fa fa-spinner fa-spin"></i>
          {{ copying ? 'Copying...' : 'Copy Settings' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'CopySettingsModal',
  props: {
    locations: { type: Array, default: () => [] },
    defaultToSiteId: { type: String, default: null } // Pre-select the "To" location
  },

  data() {
    return {
      visible: false,
      copying: false,
      fromSiteId: null,
      toSiteId: null,
      copyOptions: {
        generalSettings: true,
        appointmentTypes: true,
        blockoutRules: true
      }
    };
  },

  computed: {
    canCopy() {
      return this.fromSiteId &&
             this.toSiteId &&
             this.fromSiteId !== this.toSiteId &&
             (this.copyOptions.generalSettings || this.copyOptions.appointmentTypes || this.copyOptions.blockoutRules);
    }
  },

  methods: {
    show() {
      this.visible = true;
      this.fromSiteId = null;
      this.toSiteId = this.defaultToSiteId;
      this.copyOptions = {
        generalSettings: true,
        appointmentTypes: true,
        blockoutRules: true
      };
    },

    hide() {
      this.visible = false;
    },

    async doCopy() {
      if (!this.canCopy) return;

      this.copying = true;
      try {
        await this.$store.dispatch('onlineAppointments/copySettings', {
          fromSiteID: this.fromSiteId,
          toSiteID: this.toSiteId,
          copyOptions: this.copyOptions
        });

        this.$emit('copied', {
          fromSiteId: this.fromSiteId,
          toSiteId: this.toSiteId,
          copyOptions: this.copyOptions
        });

        this.hide();
        this.$toasted.show('Settings copied successfully!', { type: 'success', duration: 3000 });
      } catch (err) {
        this.$toasted.show('Failed to copy settings.', { type: 'error', duration: 3000 });
      } finally {
        this.copying = false;
      }
    }
  }
};
</script>
